// extracted by mini-css-extract-plugin
export default {"textEnterLayout":"TextEnter_textEnterLayout__obR+y","textEnterForm":"TextEnter_textEnterForm__E4Vsq"};